<template>
  <div
    class="additional-field-card main__light_green rounded-lg pa-6"
    :data-qa="dataqa">
    <div class="flex pb-4">
      <div
        class="additional-field-card__caption"
        :data-qa="dataqa + '-caption'">
        <span
          class="first-row"
          :class="{'required': requiredSetting && requiredSetting.value}">{{ item.caption }}</span>
        <div
          class="second-row"
          :class="{'required': requiredSetting && requiredSetting.value}">
          {{ smallFirstLetter($t('Tenders.To' + bigFirstLetter(item.bindingLevel) ) ) }}
        </div>
        <div
          class="badge is-active"
          :class="{'is-active': item.active, 'is-not-active': !item.active}">
          {{ item.active ? $t('AdditionalFields.Active1') : $t('AdditionalFields.Hiden') }}
        </div>
        <div
          v-if="item.showAsSpecialField"
          class="badge is-active is-not-active ml-2">
          {{ $t('AdditionalFields.ShowAsSpecialField') }}
        </div>
        <div
          v-if="item.entitiesCount"
          class="badge is-active ml-2">
          {{ `${$tc('Tenders.Tender', item.entitiesCount)}: ${item.entitiesCount}` }}
        </div>
      </div>
      <div>
        <v-menu
          v-if="menu_list.length"
          attach
          content-class="rounded-0"
          left
          offset-x
          offset-y>
          <template #activator="{ on }">
            <div
              class="ml-auto"
              v-on="on"
              @click.prevent="">
              <sButton
                data-qa="btn-additional-field-menu"
                icon="menu"
                small
                type="text"/>
            </div>
          </template>
          <div
            class="additional-field-card__menu menu list py-2 "
            :data-qa="dataqa + '-menu'">
            <MenuItem
              v-for="(menu_item, index) in menu_list"
              :key="index"
              :data-qa="`menu-automation-${menu_item.icon}`"
              :icon="menu_item.icon"
              :label="menu_item.text"
              @click="menu_item.click"/>
          </div>
        </v-menu>
      </div>
    </div>
    <div class="flex">
      <KeyValue
        :caption="$t('AdditionalFields.FieldType')"
        class="width-25"
        :data-qa="dataqa + '-type-name'"
        :value="itemTypeId.name"/>
      <KeyValue
        v-if="item.defaultValue && !(itemTypeId.typeId === 'CHECKBOX' && item.defaultValue === 'false')"
        :caption="$t('AdditionalFields.Content')"
        class="width-15"
        :data-qa="dataqa + '-defaultValue'"
        :value="item.defaultValue"/>
      <KeyValue
        :caption="$t('AdditionalFields.Visibility')"
        class="width-15"
        :data-qa="dataqa + '-showForBidders'"
        :value="item.showForBidders ? $t('AdditionalFields.ShowParticipantsOnSite') : $t('AdditionalFields.NotShowParticipantsOnSite')"/>
      <KeyValue
        v-if="showAsSpecialFieldAvailable"
        :caption="$t('AdditionalFields.ShowAsSpecialField')"
        class="width-15"
        :data-qa="dataqa + '-showAsSpecialField'"
        :value="item.showAsSpecialField ? $t('Tenders.Yes') : $t('Tenders.No')"/>
      <KeyValue
        :caption="$t('Tenders.TenderTypes')"
        class="width-25"
        :data-qa="dataqa + '-binded-biddingType'">
        <div
          style="max-height: 150px; overflow: auto;">
          <template v-if="itemBiddingTypes && itemBiddingTypes.length">
            <div
              v-for="biddingType in itemBiddingTypes"
              :key="biddingType.biddingTypeId"
              :class="{'text-error': biddingType.isProblem}">
              {{ biddingType.titleRu || '-' }}
            </div>
          </template>
          <div v-else>
            -
          </div>
        </div>
      </KeyValue>
      <KeyValue
        :caption="$t('Tenders.Categories')"
        class="width-25"
        :data-qa="dataqa + '-binded-category'">
        <div
          style="max-height: 150px; overflow: auto;">
          <template v-if="categorys && categorys.length">
            <div
              v-for="category in categorys"
              :key="category.classificationCode">
              {{ category.title || '–' }}
            </div>
          </template>
          <div v-else>
            -
          </div>
        </div>
      </KeyValue>
    </div>
  </div>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'
import KeyValue from 'components/common/KeyValue.vue'

import AdditionalFieldsApi from '@/api/additionalFieldsApi'
const api = new AdditionalFieldsApi()
import { modalMixin, additionalFieldsMixin } from 'mixins'
export default {
  name: 'additionalFieldCard',
  mixins: [ modalMixin, additionalFieldsMixin ],
  props: {
    /**
     * об'єкт доп поля
     */
    item: {
      type: Object,
      required: true
    },
    classifications: {
      type: Array
    },
    biddingTypes: {
      type: Array
    },
  },
  computed: {
    isBinding() {
      return !!this.item.bindingCondition
      && (!!this.item.bindingCondition?.biddingTypeIds?.filter(i => i)?.length
      || !!this.item.bindingCondition?.classificationCodes?.filter(i => i)?.length)
    },
    itemBiddingTypes() {
      if (!this.isBinding) {
        return null
      }
      const ids = this.item.bindingCondition?.biddingTypeIds || []
      const found = this.biddingTypes.filter(type => ids.includes(type.biddingTypeId))
      const foundIds = found.map(type => type.biddingTypeId)
      const notFound = ids
        .filter(id => !foundIds.includes(id))
        .map(id => ({
          biddingTypeId: id,
          titleRu: `${this.$t('Tenders.biddingTypes')} ${id}`,
          isProblem: true

        }))
      return [...found, ...notFound]
    },
    categorys() {
      if (!this.isBinding) {
        return null
      }
      if (!this.item.bindingCondition?.classificationCodes?.length) {
        return null
      }

      const result = []
      this.item.bindingCondition.classificationCodes.forEach(code => {
        const found = this.classifications.find(type => type.classificationCode === code)
        result.push(found || { classificationCode: code, title: code })
      })
      return result
    },

    itemTypeId() {
      return this.additional_types.find(additionalField => additionalField.typeId == this.item.typeId ) || {}
    },
    showAsSpecialFieldAvailable() {
      return this.item.typeId === 'DECIMAL' && this.item.bindingLevel == 'LOT'
    },
    requiredSetting() {
      let item = this.item.settingValues.find(set => set.settingType == 'REQUIRED' )
      if ( item ) {
        item.value = eval(item.value)
      }
      return item
    },

    /**
     * редагувати і видаляти можемо тільки поля без привязок до тиу тендера і категорії - // todo уточнити!
     */
    menu_list() {
      let opts =  [
        {
          text: this.$t('Common.Edit'),
          icon: 'edit',
          click: this.edit
        },
        // {text: this.$t('Catalog.Duplicate'), icon: 'docs', click: this.duplicate}, // наразі видалено, не знаю чи будемо використовувати, додати в разі не обхідності
      ]
      if (!this.item.entitiesCount) {
        opts.push(
          {
            text: this.$t('Purchasing.Remove'),
            icon: 'delete',
            click: this.remove
          }
        )
      }
      if (this.item.active) {
        opts.push(
          {
            text: this.$t('AdditionalFields.Hide'),
            icon: 'eye-slash',
            click: this.hide
          }
        )
      } else if (!this.item.active) {
        opts.push(
          {
            text: this.$t('AdditionalFields.Show'),
            icon: 'eye',
            click: this.hide
          }
        )
      }
      return opts
    },
    dataqa() {
      return 'additional-field-card-' + this.item.id
    }
  },
  methods: {
    duplicate() {
      this.$log( 'duplicate' )
    },
    edit() {
      this.$router.push({name: 'editAdditionalField', params: {org: this.$route.params.org, id: this.item.id} })
    },
    remove() {
      api.deleteAdditionaFiled(this.item.id).then(res => {
        if ( res) {
          this.$emit('delete', this.item.id)
        } else {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'), // todo get error if field is already bended to tender  FieldAlreadyBinded
            duration: 10,
          })
        }
      })
        .catch((error) => {
          const isBinded = !!error?.graphQLErrors.find(i => i.extensions?.code === 'FieldAlreadyBinded')
          if (isBinded) {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('Validate.FieldAlreadyBinded'),
              duration: 10,
            })
          }
          //console.dir(error.graphQLErrors)
        })
    },
    async hide() {
      const model = this.$_.cloneDeep(this.item)
      model.active = !model.active

      await api.updateAdditionalField(model).then((result) => {
        if (result) {
          this.$emit('update', model) // TODO: сейчас бек меняет ID при редактировании. Оставят старый, будем возвращать result
        }
      })
    },
  },
  components: {
    MenuItem,
    KeyValue
  }
}
</script>
<style lang="scss" scoped>

.badge {
  border: 1px solid green;
  display: initial;
  line-height: 1;
  font-size: 12px;
  border-radius: 15px;
  padding: 0 7px;
  color: var(--black-color);
  background: green;
  font-weight: 400;
  &.is-active {
    border-color: var(--color-success);
    background: var(--color-success);
  }
  &.is-not-active {
    border-color: var(--color-disabled);
    background: var(--color-disabled);
  }
}

.additional-field-card {
  &__menu {
    .list-item {
      cursor: pointer;
      min-height: 40px;
      position: relative;
      &:hover {
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0.3;
          background-color: var(--v-secondary__green_chosen-darken1);
        }
      }
    }
  }
  &__caption {
    text-align: start;
    padding: 0 0 4px 0;
    color: var(--black-color);
    caret-color: var(--black-color);
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.01em;
    width: calc(100% - 35px);
    line-height: 1.25;
    .first-row {
      &.required::before {
        content: '*';
        margin-right: 5px;
        font-size: 14px;
        color: var(--color-error);
      }
    }
    .second-row {
      display: block;
      font-size: 13px;
      &.required {
        padding-left: 13px;
      }
    }
  }
}
</style>
